import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Mail, CheckCircle2, XCircle, ArrowRight } from "lucide-react";
import SEO from "@/components/common/SEO";
import { api } from "@/lib/api";

export default function NoMasCorreos() {
    const loc = useLocation();
    const [state, setState] = useState({ loading: true, ok: false, error: null });

    useEffect(() => {
        const params = new URLSearchParams(loc.search);
        const order = params.get("order");
        const token = params.get("token");
        if (!order || !token) {
            setState({
                loading: false,
                ok: false,
                error: "Enlace inválido o incompleto.",
            });
            return;
        }
        api.get(`/follow-up/opt-out?order=${encodeURIComponent(order)}&token=${encodeURIComponent(token)}`)
            .then(() => setState({ loading: false, ok: true, error: null }))
            .catch((err) => {
                const detail =
                    err.response?.data?.detail ||
                    "No pudimos procesar la baja. Inténtalo más tarde.";
                setState({ loading: false, ok: false, error: detail });
            });
    }, [loc.search]);

    return (
        <>
            <SEO
                title="Baja de correos · El Mapa Inverso"
                description="Procesar la baja del envío de follow-up del libro."
                path="/no-mas-correos"
                noindex
            />
            <section className="py-20 md:py-28" data-testid="optout-section">
                <div className="container-x max-w-2xl">
                    <div className="dossier">
                        <div className="dossier-header">
                            <span>EMI · Preferencias de email</span>
                            <span className={state.ok ? "text-[var(--warning)]" : "text-[var(--ink-muted)]"}>
                                {state.loading ? "Procesando…" : state.ok ? "Listo" : "No procesado"}
                            </span>
                        </div>
                        <div className="px-6 py-12 md:px-12 md:py-16 text-center">
                            {state.loading ? (
                                <>
                                    <Mail className="w-14 h-14 text-[var(--ink-muted)] mx-auto mb-6 animate-pulse" />
                                    <p className="font-mono text-sm text-[var(--ink-muted)]">
                                        Dándote de baja…
                                    </p>
                                </>
                            ) : state.ok ? (
                                <>
                                    <CheckCircle2 className="w-16 h-16 text-[var(--warning)] mx-auto mb-6" />
                                    <h1 className="font-display text-4xl md:text-5xl text-[var(--paper-2)] mb-4 leading-[1.05]">
                                        Listo.{" "}
                                        <span className="text-[var(--danger)]">
                                            No te escribo más.
                                        </span>
                                    </h1>
                                    <p className="font-mono text-sm text-[var(--paper)] leading-relaxed mb-3 max-w-md mx-auto">
                                        No vas a recibir más correos míos sobre este libro.
                                    </p>
                                    <p className="font-mono text-xs text-[var(--ink-muted)] leading-relaxed mb-10 max-w-md mx-auto">
                                        Si quieres seguir teniendo el libro, el enlace de descarga
                                        del correo original sigue funcionando para siempre.
                                        Si en algún momento cambias de opinión, puedes volver a{" "}
                                        <Link to="/descargar" className="underline hover:text-[var(--warning)]">
                                            descargarlo desde acá
                                        </Link>.
                                    </p>
                                    <div className="flex flex-wrap gap-3 justify-center">
                                        <Link
                                            to="/"
                                            className="btn-brutal btn-brutal-ghost"
                                            data-testid="optout-home"
                                        >
                                            <ArrowRight className="w-4 h-4" />
                                            Volver al sitio
                                        </Link>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <XCircle className="w-16 h-16 text-[var(--danger)] mx-auto mb-6" />
                                    <h1 className="font-display text-3xl md:text-4xl text-[var(--paper-2)] mb-4 leading-tight">
                                        No pudimos procesar la baja.
                                    </h1>
                                    <p className="font-mono text-sm text-[var(--paper)] leading-relaxed mb-3 max-w-md mx-auto">
                                        {state.error}
                                    </p>
                                    <p className="font-mono text-xs text-[var(--ink-muted)] leading-relaxed mb-8 max-w-md mx-auto">
                                        Si crees que es un error, responde directamente el
                                        correo que recibiste de Nelson y te damos de baja a mano.
                                    </p>
                                    <Link
                                        to="/"
                                        className="btn-brutal btn-brutal-ghost"
                                        data-testid="optout-home"
                                    >
                                        <ArrowRight className="w-4 h-4" />
                                        Volver al sitio
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
